module.exports = __webpack_public_path__ + "img/sf-logo.96ce7777.png";